// @flow

import React from 'react';
import pdf from '../../../../resources/apollo_calculation_rules.pdf';

type Props = {
  label: any,
  unit?: string,
  prefix?: string,
  isMainRetailer: boolean,
  isGreen?: boolean,
  isBig?: boolean,
  updateFormula?: ?Function,
}

class TuileRow extends React.PureComponent<Props> {
  static defaultProps = {
    legend: '',
    prefix: '',
    unit: '',
    isBig: false,
    isGreen: false,
    updateFormula: null,
  };

  render() {
    if (this.props.isMainRetailer === true) {
      return (
        <div className="tile-row">
          {this.props.prefix && <div className="legend-bold">{this.props.prefix} : </div>}
          <div className={this.props.prefix ? 'force-align-center' : 'small-side-paddings'}>
            {this.props.label} {this.props.unit}
            {
              this.props.prefix
              && this.props.updateFormula
              && (
                <div
                  className="rounded-button little-info-button"
                >
                  <a target="_blank" href={pdf} rel="noopener noreferrer"> <i className="fa fa-info-circle" /></a>
                </div>
              )
            }
          </div>
        </div>
      );
    }

    if (!this.props.label) {
      return (
        <div className="tile-row">
          N/A
        </div>
      );
    }
    return (
      <div className="tile-row">
        <div className={this.props.isGreen ? 'green-text' : 'red-text'}>
          <div className={this.props.isBig ? 'big-text' : ''}>
            {this.props.label} {this.props.unit}
          </div>
        </div>
      </div>
    );
  }
}

export default TuileRow;
